__turbopack_context__.v({
  "container": "FeatureIcon-module__LZ-wWG__container",
  "icon": "FeatureIcon-module__LZ-wWG__icon",
});
